<div class="more-buttons" appClickOutside (clickOutside)="close()" *ngIf="showMore">
  <div [@listParent]="len" class="notification-list">
    <div *ngFor="let item of (buttons | async) | slice:(menuSize|async): (buttons | async).length">
      <app-nav-button [menuItem]="item" [isCollapsed]="false" [external]="true"></app-nav-button>
    </div>
  </div>
</div>
